export default "__VITE_ASSET__BtccHwlk__"